export default __webpack_public_path__ + "static/Entenda0135-b66e32ffb7e8836f4a8cabb0b67a3757.jpg";